// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Image_imageWrapper__2G6a8","image":"Image_image__1xY20","image_loading":"Image_image_loading__3rdt8"};